// extracted by mini-css-extract-plugin
export default {"container":"WhiteBlock_container__8uniE","text":"WhiteBlock_text__Bh01t"};